import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";

import { WatchedAssignedContentTable } from "../watchedAssignedContentTable";
import { useFilterPagination } from "../../../shared/hooks/useFilterPagination";
import { getWatchedAssignedContents } from "../../service";
import { getEmptyStateMessage } from "../../../shared/helpers/emptyMessageState";

const useStyles = makeStyles(() => ({
  marginSpacing: {
    marginTop: 30,
    marginBottom: 30,
  },
}));

const DEFAULT_SEARCH = {
  keyword: "",
};

export const WatchedAssignedContentList = ({ navigation }) => {
  const classes = useStyles();
  const [search, setSearch] = useState({
    ...DEFAULT_SEARCH,
  });

  const {
    order,
    orderBy,
    infiniteRef,
    isFetching,
    sourceData,
    totalDataRecords,
    debouncedHandleSortChange,
    debouncedHandleFilterChange,
  } = useFilterPagination(
    getWatchedAssignedContents,
    10,
    "assignedContentId",
    { ...DEFAULT_SEARCH, status: null },
    ""
  );

  const handleRequestSort = useCallback(
    (property) => {
      const isAsc = orderBy === property && order === "asc";
      debouncedHandleSortChange(property, isAsc ? "desc" : "asc");
    },
    [orderBy, order, debouncedHandleSortChange]
  );

  const handleFilterTableChange = (event) => {
    const { value, name } = event.target;
    setSearch({ ...search, [name]: value });
    debouncedHandleFilterChange(value, name);
  };

  const filters = [
    {
      name: "keyword",
      id: "keyword",
      type: "text",
      label: "Keyword",
      value: search.keyword,
      onChange: handleFilterTableChange,
    },
  ];

  return (
    <>
      <Grid container navigation={navigation}>
        <Grid item>
          <Typography>{`Total Records: ${totalDataRecords}`}</Typography>
        </Grid>
      </Grid>
      <Grid container>
        {!sourceData.length && (
          <Grid item>
            <Typography align="center" variant="h6">
              {getEmptyStateMessage(
                search,
                DEFAULT_SEARCH,
                "You don't have any watched content"
              )}
            </Typography>
          </Grid>
        )}
      </Grid>
      <Grid
        className={classes.marginSpacing}
        spacing={5}
        container
        ref={infiniteRef}
      >
        <WatchedAssignedContentTable
          content={sourceData}
          order={order}
          orderBy={orderBy}
          onSortChange={handleRequestSort}
          filters={filters}
        />
        {isFetching && <Typography>Loading...</Typography>}
      </Grid>
    </>
  );
};

WatchedAssignedContentList.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

WatchedAssignedContentList.defaultProps = {
  navigation: [],
};
